import React from 'react'

import './styles.scss'
import PageBackground from '../../../assets/images/404-background.svg'
import PageBackgroundMini from '../../../assets/images/404-background-mini.svg'
import { useNavigate } from 'react-router-dom'
import uris from '../../../config/uris'
import { decryptData } from '../../../helpers/encrypt/crypto-encrypt'

const Page404 = () => {
    const role_decrypt = decryptData(sessionStorage.getItem('eqlwoer'))
    const isRoleAvailable = role_decrypt?.role || ''
    const navigate = useNavigate()

    const handleRedirect = () => {
        if (isRoleAvailable) {
            navigate(uris?.companyResearch)
        } else {
            navigate(uris?.login)
        }
    }

    return (
        <div className="error-404-main">
            <div className="error-background-container">
                <img src={PageBackground} alt="404 Page Background" className="background-image" />
                <img src={PageBackgroundMini} alt="404 Page Background" className="background-image-mini" />
            </div>
            <div className="error-contents">
                <div className="error-status">404</div>
                <div className="error-message">Sorry! Page not found</div>
                <div className="redirect-button" onClick={() => handleRedirect()}>
                    {!isRoleAvailable ? 'Login' : 'Go to Home Page'}
                </div>
            </div>
        </div>
    )
}

export default Page404